var _rect, _path, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    y: 0.333252,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#5200FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7775 12.5555C13.5502 12.5555 12.5552 13.5504 12.5552 14.7777V20.9841L15.1029 18.4364L15.1181 18.4214C15.7875 17.7774 16.6266 17.3667 17.5552 17.3667C18.4839 17.3667 19.323 17.7774 19.9923 18.4214L20.0076 18.4364L22.5552 20.9841L22.8807 20.6586L22.8959 20.6437C23.5652 19.9996 24.4043 19.5889 25.333 19.5889C26.2617 19.5889 27.1008 19.9996 27.7701 20.6437L27.7853 20.6586L28.1108 20.9841V14.7777C28.1108 13.5504 27.1159 12.5555 25.8886 12.5555H14.7775ZM30.333 23.6654V14.7777C30.333 12.3231 28.3432 10.3333 25.8886 10.3333H14.7775C12.3229 10.3333 10.333 12.3231 10.333 14.7777V23.6663C10.333 23.6662 10.333 23.6665 10.333 23.6663V25.8888C10.333 28.3434 12.3229 30.3333 14.7775 30.3333H25.8886C28.3432 30.3333 30.333 28.3434 30.333 25.8888V23.6676C30.333 23.6669 30.333 23.6662 30.333 23.6654ZM28.1108 24.1268L26.2223 22.2383C25.8809 21.9124 25.5729 21.8111 25.333 21.8111C25.0931 21.8111 24.7851 21.9124 24.4437 22.2383L24.1266 22.5554L25.5631 23.992C25.997 24.4259 25.997 25.1294 25.5631 25.5633C25.1292 25.9972 24.4257 25.9972 23.9918 25.5633L18.4445 20.016C18.1031 19.6902 17.7952 19.5889 17.5552 19.5889C17.3153 19.5889 17.0073 19.6902 16.666 20.016L12.5552 24.1268V25.8888C12.5552 27.1161 13.5502 28.111 14.7775 28.111H25.8886C27.1159 28.111 28.1108 27.1161 28.1108 25.8888V24.1268ZM22.5552 15.8888C22.5552 15.2752 23.0527 14.7777 23.6663 14.7777H23.6775C24.2911 14.7777 24.7886 15.2752 24.7886 15.8888C24.7886 16.5025 24.2911 16.9999 23.6775 16.9999H23.6663C23.0527 16.9999 22.5552 16.5025 22.5552 15.8888Z",
    fill: "white",
    stroke: "#5200FF",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.6665,
    y: 20.3333,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#5200FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6663 22.9999C30.0345 22.9999 30.333 23.2984 30.333 23.6666V27.6666H34.333C34.7012 27.6666 34.9997 27.9651 34.9997 28.3333C34.9997 28.7014 34.7012 28.9999 34.333 28.9999H30.333V32.9999C30.333 33.3681 30.0345 33.6666 29.6663 33.6666C29.2982 33.6666 28.9997 33.3681 28.9997 32.9999V28.9999H24.9997C24.6315 28.9999 24.333 28.7014 24.333 28.3333C24.333 27.9651 24.6315 27.6666 24.9997 27.6666H28.9997V23.6666C28.9997 23.2984 29.2982 22.9999 29.6663 22.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.97e36fd7bd329211bf00d7715bde7065.svg";
export { ForwardRef as ReactComponent };